"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    ReceiptLineValue: ()=>ReceiptLineValue
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const index_cjs_namespaceObject = require("../Price/index.cjs");
const external_PlainButton_index_cjs_namespaceObject = require("../PlainButton/index.cjs");
const external_Text_index_cjs_namespaceObject = require("../Text/index.cjs");
const external_ReceiptLineValue_variants_cjs_namespaceObject = require("./ReceiptLineValue.variants.cjs");
const external_utils_index_cjs_namespaceObject = require("../../utils/index.cjs");
function ReceiptLineValue({ children, className, type = 'price', priceCurrencySymbol = '', pricePrefix, price = '', priceSuffix, priceIsStrike = false, textStyle = 'body2', textPalette = 'neutral', pricePalette, bold = false, onClickPlainButton, isMinusSign = false, isFormatted = false, ...props }) {
    const { root, paragraph } = (0, external_ReceiptLineValue_variants_cjs_namespaceObject.receiptLineValueVariant)(props);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        className: (0, external_utils_index_cjs_namespaceObject.cn)(root(), className),
        ...props,
        children: [
            'plainButton' === type && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_PlainButton_index_cjs_namespaceObject.PlainButton, {
                onClick: onClickPlainButton,
                type: "primary",
                textStyle: textStyle,
                children: children
            }),
            'string' === type && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Text_index_cjs_namespaceObject.P, {
                textStyle: textStyle,
                palette: textPalette,
                className: (0, external_utils_index_cjs_namespaceObject.cn)(paragraph(), className),
                bold: bold,
                children: children
            }),
            'price' === type && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.Price, {
                className: className,
                currencySymbol: priceCurrencySymbol,
                prefix: pricePrefix,
                price: price,
                suffix: priceSuffix,
                textStyle: textStyle,
                type: pricePalette ?? textPalette,
                bold: bold,
                isStrike: priceIsStrike,
                isMinusSign: isMinusSign,
                isFormatted: isFormatted
            })
        ]
    });
}
exports.ReceiptLineValue = __webpack_exports__.ReceiptLineValue;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "ReceiptLineValue"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
